import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import * as React from 'react'
import { useCallback } from 'react'

import type { CommitHandler, FormattedBestFit } from '../typings'

type AlternateTimeProps = {
  result: FormattedBestFit
  commitProcessing: boolean
  commitResult: CommitHandler
}

export function AlternateTime(props: AlternateTimeProps) {
  const {
    commitResult,
    commitProcessing,
    result: { resultId, buttonLabel, time },
  } = props

  const onClick = useCallback(
    () => commitResult(resultId),
    [commitResult, resultId],
  )

  return (
    <div>
      {!!time && <Typography variant="body2">{time}</Typography>}
      <Button
        onClick={onClick}
        variant="contained"
        disabled={commitProcessing}
        data-test-id={`results-commit-${resultId}`}
      >
        {buttonLabel}
      </Button>
    </div>
  )
}
